import { ExtraInfo } from '../other/extraInfo-dto';
import { PaginationDTO } from '../other/pagination-dto';
import { TagsDTO } from './tags-dto';
import { MediaVersionDTO } from './media-version-dto';

export class MediaRepsonse {
  metadata: PaginationDTO;

  medias: MediaDTO[];
}
export class MediaDTO extends ExtraInfo {
  _id: string;

  code?: string;

  name?: string;

  type: string;

  filename: string;

  product_code?: string;

  url?: MediaUrlDTO;

  view: string;

  last_version?: MediaVersionDTO;

  description?: string;

  folder_code?: string;

  mimetype: string;

  state?: string;

  tags?: TagsDTO[];

  digital_rights?: DigitalRightsDTO;

  isSelected?: boolean;

  size?: number;

  media_url?: string;
}

export enum State {
  shooting,
  post_production,
  library,
}

export interface MediaUrlDTO {
  url: string;

  hash_url?: string;

  size?: MediaSizeDTO;
}

export class MediaSizeDTO {
  name?: string;

  code: string;

  width: string;

  height: string;
}

export class DigitalRightsDTO extends ExtraInfo {
  author?: string;

  agency?: string;

  notes?: string;

  expiration_date?: string;

  copyright_validity?: string;
}

export class MediasZipDownload {
  filenames?: string[];

  media_codes?: string[];

  // media code for heritage download
  code?: string[];

  state: string;
}

export class MediasZipResponse {
  total?: number;

  successed?: number;

  failed?: number;

  errors?: MediasZip[];
}
export class MediasZip {
  message?: string;

  filename?: string;
}
